import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { LogsRoutingModule } from './routing';
import { ListadoRequestHttpComponent } from './listado-request-http/listado-request-http.component';
import { DetallesRequestHttpComponent } from './detalles-request-http/detalles-request-http.component';
import { JsonTreeComponent } from './json-tree/json-tree.component';
import { ListadoEventosLoraComponent } from './listado-eventos-lora/listado-eventos-lora.component';
import { MetricasDownlinksComponent } from './metricas-downlinks/metricas-downlinks.component';

@NgModule({
  declarations: [
    //Request Http
    ListadoRequestHttpComponent,
    //Eventos Mqtt
    ListadoEventosLoraComponent,
  ],

  imports: [
    CommonModule,
    AuxiliaresModule,
    LogsRoutingModule,
    DetallesRequestHttpComponent,
    JsonTreeComponent,
    MetricasDownlinksComponent,
  ],
})
export class LogsModule {}
